// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9bdba7f7","185":"8ef5e42f","237":"a3fa1789","268":"b1106464","505":"c68b6110","748":"ccfc315a","890":"38d11e8f"}[chunkId] + ".chunk.js";
};